import ReactDOM from 'react-dom';
import 'antd/dist/reset.css';
import './index.css';
import App from './app';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store';
import { ConfigProvider } from 'antd';

ReactDOM.render(
	<ConfigProvider
		theme={{
			token: {
				colorPrimary: '#FF0550',
			},
		}}>
		<BrowserRouter>
			<Provider store={store}>
				<App />
			</Provider>
		</BrowserRouter>
	</ConfigProvider>,
	document.getElementById('root'),
);
